module.exports = __webpack_public_path__ + "static/media/share-icon.d5e82f63.svg";